<template>
  <div class="area-content" style="position: relative">
    <div ref="area" class="mainArea">
      <div class="patient-box">
        <div class="head-pic">
          <img v-if="reportDetail.orsl_Consumer_gender == '男'" src="../../assets/img/manlogo.png" alt="" />
          <img v-else src="../../assets/img/womanlogo.png" alt="" />
        </div>
        <div class="patient-info">
          <p>{{ reportDetail.orsl_Consumer_name ? reportDetail.orsl_Consumer_name : '' }}</p>
          <p>
            {{ reportDetail.orsl_Consumer_gender ? reportDetail.orsl_Consumer_gender : '' }}/{{
              reportDetail.orsl_Consumer_age ? reportDetail.orsl_Consumer_age : ''
            }}/{{ reportDetail.orsl_Consumer_mobile_number ? reportDetail.orsl_Consumer_mobile_number : '' }}
          </p>
        </div>
      </div>
      <div class="order-box">
        <p class="order-title">订单基础信息</p>
        <p class="order-info">订单编号:{{ reportDetail.DocumentNo ? reportDetail.DocumentNo : '' }}</p>
        <p class="order-info">检测时间:{{ reportDetail.Creationtime ? reportDetail.Creationtime : '' }}</p>
        <p class="order-info">网点名称:{{ reportDetail.cal_name ? reportDetail.cal_name : '' }}</p>
        <p class="order-info">开单医生:{{ reportDetail.orsl_Billing_doctor ? reportDetail.orsl_Billing_doctor : '' }}</p>
        <p class="order-info order-info2">
          条形码:<span v-for="(item, index) in reportDetail.Order_detail_barcode" :key="index">{{ item.orcab_barcode }};</span>
        </p>
      </div>
      <div class="project-box" v-for="(val4, key4) in reportDetail.Order_detail_Library" :key="key4">
        <p class="project-title">{{ val4.psl_name }}</p>
        <div class="project-single" style="background: #eff8ff; font-weight: bold">
          <div class="single-left" style="color: #333333; font-size: 16px">检查名称</div>
          <div class="single-middle" style="color: #333333; font-size: 16px">结果</div>
          <div class="single-right" style="color: #333333; font-size: 16px">参数范围</div>
        </div>
        <div
          class="project-single"
          :style="{
            background: key5 % 2 === 0 ? '#D7EEFF' : '#eff8ff',
            color: val5.orbpd_Result_marker == 'L' || val5.orbpd_Result_marker == 'H' ? 'red' : '#333333'
          }"
          v-for="(val5, key5) in val4.order_breakdown_product_summary[0].order_breakdown_product_details"
          :key="key5"
        >
          <div class="single-left">{{ val5.pdl_name }}</div>
          <div class="single-middle">
            {{ val5.papdl_Return_value ? val5.papdl_Return_value : ''
            }}{{ val5.pdl_Return_value_unit ? val5.pdl_Return_value_unit : '' }} &nbsp;&nbsp;&nbsp;
            <span v-if="val5.orbpd_Result_marker == 'H'"><i class="iconfont iconshangsheng"></i></span>
            <span v-if="val5.orbpd_Result_marker == 'L'"><i class="iconfont iconxiajiang"></i></span>
          </div>
          <div class="single-right">{{ val5.pdl_Reference_range ? val5.pdl_Reference_range : '' }}</div>
        </div>
        <!-- <div class="project-single" style="background: #eff8ff">
          <div class="single-left">中性粒细胞百分比</div>
          <div class="single-middle">59.1</div>
          <div class="single-right">1.10-3.20</div>
        </div> -->
      </div>
      <div class="report-box" v-if="Interpretation.length > 0">
        <div class="report-header">报告解读</div>
        <div class="repotr-content" v-for="(item, index) in Interpretation" :key="index">
          <div class="project-single">
            <div class="single-left">{{ index + 1 }}:{{ item.pdl_name }}</div>
            <div class="single-middle">结果:{{ item.papdl_Return_value }}</div>
            <div v-if="item.orbpd_Result_marker == 'H'" class="single-right" style="color: red; font-weight: bold; font-size: 20px">
              <i class="iconfont iconshangsheng"></i>
            </div>
            <div v-if="item.orbpd_Result_marker == 'L'" class="single-right" style="color: red; font-weight: bold; font-size: 20px">
              <i class="iconfont iconxiajiang"></i>
            </div>
          </div>
          <div class="project-describe">
            {{ item.orbps_Interpretation_of_doctors }}
          </div>
        </div>
      </div>
    </div>
    <div class="imgBox" style="display: none">
      <div class="imgMain">
        <p style="font-size: 14px; font-weight: bold; color: rgb(88, 88, 88)">长按图片保存或分享</p>
        <!-- <div style="white-space: normal; word-break: break-all">订单号5：{{ orderNumber }}</div>
        <div style="border: 1px solid red">{{ imgUrl }}</div> -->
        <div class="canvasImg">
          <img src="" alt="" id="canvasPic" />
        </div>
      </div>
    </div>
    <!-- <el-button style="position: fixed; right: 0; top: 0; z-index: 9" type="primary" @click="generateImage">生成图片</el-button> -->
  </div>
</template>

<script>
import request from '@/utils/request';
export default {
  name: 'ScreenShot',
  data: function () {
    return {
      heightL: null,
      imgUrl: '',
      orderNumber: '',
      orderToken: '',
      reportDetail: {},
      Interpretation: [],
      loading: null
    };
  },
  beforeCreate() {
    document.title = '图片预览';
    this.loading = this.$loading({
      lock: true,
      text: '图片生成中...',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 1)'
    });
  },
  async created() {  
    let params = this.getParamsFromURL(window.location.href);
    if (params && params.orderno) {
      this.orderNumber = params.orderno;
      this.orderToken = params.token;
      this.$message.success("订单编号：" + this.orderNumber);
    } else {
      this.$message.error('抱歉，查询报告已出报告列表出错');
      return false;
    }
    // this.orderNumber = 'ORSL2021122302073';
    // this.orderToken = '98673405-29AB-0B10-9D7B-1DA0FD4B4108';
    await this.getAllOverReportList();
  },
  mounted() {},
  updated() {
    const that = this;
    this.$nextTick(() => {
      that.generateImage();
    });
  },
  methods: {
    // 报告解读处理
    handleFun() {
      // console.log(this.reportItem, ':::::reportItem');
      this.Interpretation = [];
      this.reportDetail.Order_detail_Library.map((item) => {
        item.order_breakdown_product_summary[0].order_breakdown_product_details.map((item1) => {
          if (item1.orbps_Interpretation_of_doctors) {
            let obj = {
              orbps_Interpretation_of_doctors: item1.orbps_Interpretation_of_doctors,
              pdl_name: item1.pdl_name,
              papdl_Return_value: item1.papdl_Return_value,
              orbpd_Result_marker: item1.orbpd_Result_marker
            };
            this.Interpretation.push(obj);
          }
        });
      });
      // console.log(this.Interpretation, ':::::Interpretation');
    },
    // 拉取订单
    getAllOverReportList() {
      const that = this;
      let dataP = {
        DocumentNo: that.orderNumber
      };
      const params = {
        token: that.orderToken,
        workid: '9cc61bd8-3a9d-3846-ffa2-e9e79bc0ee86',
        data: JSON.stringify(dataP)
      };
      request
        .post('/server/getdatalisapi.php', params)
        .then((res) => {
          if (res.Order_summary_Library.length === 0) {
            that.$message.error('抱歉，未查询到此报告');
            return false;
          }
          that.reportDetail = res.Order_summary_Library[0];
          that.handleFun();
        })
        .catch((err) => {
          that.$message.error('抱歉，查询出错');
        });
    },
    // 获取网址参数
    getParamsFromURL(url) {
      if ('undefined' == url) {
        return {};
      }
      let paraString = url.substring(url.indexOf('?') + 1, url.length).split('&');
      let paraObj = {};
      for (let i = 0; i < paraString.length; i++) {
        let j = paraString[i];
        paraObj[j.substring(0, j.indexOf('='))] = j.substring(j.indexOf('=') + 1, j.length);
      }
      return paraObj;
    },
    // 生成截图关键方法
    generateImage() {
      const rect = this.$refs.area.getBoundingClientRect(); // 关键代码
      // 4、解决页面滚动一部分后，点击截图出现截取不全的问题，需要页面滚动到顶部
      window.pageYoffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // this.heightL = rect.height + 50;
      this.$html2canvas(this.$refs.area, {
        // scrollY: rect.top, // 关键代码
        // height: rect.height + 50 // 加高度，避免截取不全
        useCORS: true,
        width: rect.width,
        height: rect.height + 20,
        windowWidth: rect.width,
        windowHeight: rect.height + 20,
        x: 0,
        y: window.pageYOffset,
        scale: 1 //设置放大的倍数
      }).then((canvas) => {
        canvas.toBlob((blob) => {
          var imgBoxEle = document.getElementsByClassName('imgBox')[0];
          imgBoxEle.style.display = 'block';
          // 1、这段是pc浏览器上截图实现的方式
          // this.imgUrl = URL.createObjectURL(blob)
          // const aImg = document.createElement('a')
          // aImg.href = this.imgUrl
          // aImg.download = Date.now() + '.png'
          // document.body.appendChild(aImg)
          // aImg.click()
          // document.body.removeChild(aImg)

          // 2、将上面的全部注释改成这5行，可以截图，但出现截取不全
          // this.imgUrl = URL.createObjectURL(blob)
          // const aImg = document.createElement('img')
          // aImg.style = 'border:1px solid #000;width: 300px;height: auto;position:fixed;top:0;left:0;'
          // aImg.src = this.imgUrl
          // document.body.appendChild(aImg)

          // 3、解决截图不全的问题，注释掉的是最初截图生成的图片直接显示在最下面了，需要的样式是覆盖当前页面并可以滚动
          this.imgUrl = canvas.toDataURL('image/jpeg');
          // const aImg = document.createElement('img')
          const aImg = document.getElementById('canvasPic');
          // aImg.style = 'border:1px solid #000;width: 90%;height: auto;-webkit-touch-callout: none;vertical-align: top;position: fixed;top: 30;margin-left: 20'
          aImg.style = 'width: 100%;height: auto;-webkit-touch-callout: none;margin-left: 20';
          aImg.src = this.imgUrl;
          // document.body.appendChild(aImg)
        }, 'image/png');

        setTimeout(() => {
          this.loading.close();
        }, 2000);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// /deep/ #app {
//   overflow: auto !important;
// }
.area-content {
  height: 100vh;
  width: 100%;
  overflow-y: scroll;
  box-sizing: border-box;
}
.mainArea {
  // position: absolute;
  // top: 1000px;
  // left: 0;
  width: 414px;
  height: auto;
  // border: 1px solid red;
  box-sizing: border-box;
  background-color: #f6f6f6;
  padding: 5px 10px;
  .patient-box {
    width: 100%;
    height: 77px;
    border-radius: 6px;
    background-color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    .head-pic {
      width: 55px;
      height: 55px;
      //  border: 1px solid red;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .patient-info {
      margin-left: 20px;
      // height: 55px;
      // display: flex;
      // flex-direction: column;
      // border: 1px solid red;
      p {
        font-size: 14px;
      }
    }
  }
  .order-box {
    width: 100%;
    height: auto;
    padding: 10px 10px;
    border-radius: 6px;
    background-color: #fff;
    box-sizing: border-box;
    // border: 1px solid red;
    margin-top: 20px;
    .order-title {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      color: #333333;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .order-info {
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      text-align: left;
      color: #333333;
      margin-bottom: 6px;
      white-space: normal;
      word-break: break-all;
    }
  }
  .project-box {
    width: 100%;
    height: auto;
    padding: 10px 10px;
    border-radius: 6px;
    background-color: #fff;
    box-sizing: border-box;
    margin-top: 20px;
    .project-title {
      width: 100%;
      min-height: 40px;
      padding: 10px 0;
      box-sizing: border-box;
      // border: 1px solid red;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #0087ff;
      font-size: 18px;
      font-weight: bold;
      white-space: normal;
      word-break: break-all;
    }
    .project-single {
      width: 100%;
      min-height: 46px;
      // border: 1px solid red;
      display: flex;
      align-items: center;
      // justify-content: center;
      color: #333333;
      font-size: 14px;
      background: #d7eeff;
      padding: 5px 0 5px 5px;
      box-sizing: border-box;
      .single-left {
        width: 170px;
        min-height: 40px;
        // border: 1px solid red;
        display: flex;
        align-items: center;
        white-space: normal;
        word-break: break-all;
      }
      .single-middle {
        width: 120px;
        min-height: 40px;
        // border: 1px solid red;
        display: flex;
        align-items: center;
        white-space: normal;
        word-break: break-all;
      }
      .single-right {
        width: 120px;
        min-height: 40px;
        // border: 1px solid red;
        display: flex;
        align-items: center;
        white-space: normal;
        word-break: break-all;
      }
    }
  }
  .report-box {
    width: 100%;
    height: auto;
    padding: 10px 0px;
    border-radius: 6px;
    background-color: #fff;
    box-sizing: border-box;
    margin-top: 20px;
    .report-header {
      height: 40px;
      width: 100%;
      text-align: center;
      line-height: 45px;
      color: #0087ff;
      font-size: 18px;
      font-weight: bold;
    }
    .repotr-content {
      width: 100%;
      margin-bottom: 20px;
      .project-single {
        width: 100%;
        // border: 1px solid red;
        display: flex;
        align-items: center;
        // justify-content: center;
        color: #333333;
        font-size: 14px;
        background: #e8eaec;
        padding: 5px 0 5px 5px;
        box-sizing: border-box;
        .single-left {
          width: 260px;
          min-height: 30px;
          // border: 1px solid red;
          display: flex;
          align-items: center;
        }
        .single-middle {
          width: 120px;
          min-height: 30px;
          // border: 1px solid red;
          display: flex;
          align-items: center;
        }
        .single-right {
          width: 34px;
          min-height: 30px;
          // border: 1px solid red;
          display: flex;
          align-items: center;
        }
      }
      .project-describe {
        width: 100%;
        padding: 10px 10px;
        // border: 1px solid red;
        color: #8e8c8c;
        font-size: 14px;
        box-sizing: border-box;
      }
    }
  }
}
.imgBox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #eee;
  color: #607d8b;
  text-align: center;
  z-index: 10000;
  .imgMain {
    position: relative;
    margin: 0;
    padding: 0 0 15px 0;
    width: 100%;
    max-width: 750px;
    min-width: 300px;
    height: auto;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    p {
      padding: 10px 0px;
    }
    .canvasImg {
      max-height: 650px;
      position: relative;
      margin-left: 15px;
      margin-right: 15px;
      overflow-x: hidden;
      overflow-y: auto;
      img {
        width: 100%;
        height: auto;
        background: #525252;
      }
    }
  }
}
</style>
